module.exports = __webpack_public_path__ + "static/media/chef.59d765db.svg";